// extracted by mini-css-extract-plugin
module.exports = {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__3jt55","subTitleBold":"BoxSubTitle_subTitleBold__1uV8k"};